import { render, staticRenderFns } from "./PersistReponsavelAssociadoView.vue?vue&type=template&id=16e3a3c2&"
import script from "./PersistReponsavelAssociadoView.vue?vue&type=script&lang=ts&"
export * from "./PersistReponsavelAssociadoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports